export default {
  avatar: {
    title: "アバターを変更",
  },
  bindRole: {
    allServers: "オールサーバー",
    bindFailed: "キャラ連携失敗",
    bindSuccess: "キャラ連携成功",
    getRoleListFailed: "キャラリスト取得失敗",
    getServerListFailed: "サーバーリスト取得失敗",
    modifyTitle: "連携キャラクターを変更",
    noRole: "現在キャラクターがありません",
    recentServers: "ホストサーバー",
    role: "キャラクター名:",
    rolePlaceholder: "キャラクターを選択してください",
    server: "サーバー:",
    serverPlaceholder: "サーバーを選択してください",
    title: "キャラ連携",
  },
  commentModal: {
    placeholder: "コメントを書く...",
    replyTo: "返信{username}",
    title: "コメント",
  },
  common: {
    cancel: "キャンセル",
    confirm: "確定",
    landscapeTip:
      "より良い体験のために、スマートフォンを縦向きに回転させてください",
    loadMore: "上にスワイプしてさらに読み込む",
    loading: "読み込み中...",
    loadingMore: "さらに読み込む...",
    noMore: "これ以上のデータはありません",
    refreshFailed: "更新失敗",
    refreshSuccess: "更新成功",
    submit: "提出",
    all: "すべて",
    language: "言語",
  },
  error: {
    50002: "トークンが無効または期限切れです",
    50006: "このニックネームは既に他のユーザーに使用されています",
    50007: "ニックネームは月に1回のみ変更可能です。今月は既に変更済みです",
    50008: "ポイント不足",
    50301: "投稿する権限がありません",
    50302: "投稿回数が上限に達しました",
    50303: "内容の長さが要件を満たしていません",
    50304: "内容に不適切な言葉が含まれています。修正してから再度お試しください",
    50308: "こちらの投稿を閲覧する権限がございません",
    50309: "投稿は削除されたか、移動されました",
    50351: "スレッドはクローズされており、返信できません",
    50353: "返信する権限がありません",
    50354: "このスレッドでは返信が禁止されています",
    50355: "投稿が頻繁すぎます。しばらくしてからもう一度お試しください",
    50356: "1時間あたりの投稿数が上限に達しました",
    50361: "コメントが存在しません",
    50500: "検索権限がありません",
    50501: "検索機能は現在停止中です",
    50502: "内容に不適切な言葉が含まれています。修正してから再度お試しください",
    50505: "検索が頻繁すぎます。しばらくしてからもう一度お試しください",
    50703: "画像審査に通過しませんでした",
    50704: "申し訳ございませんが、画像の内容が規定に適合しておりません",
    50214: "共有に失敗しました。@:shareModal.allianceに加入していません",
    common: "操作に失敗しました。後ほど再度お試しください。",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "サインイン済み",
    loginInSuccess: "ログイン成功",
    pleaseLogin: "ログインしてください。",
    loginNow: "ログイン",
    pullToRefresh: "プルダウンで更新",
    releaseToRefresh: "離して更新",
    signFailed: "サインインに失敗いたしました",
    signIn: "サインイン",
    signInFailedTip: "サインインに失敗しました。後でもう一度お試しください",
    signSuccess: "サインイン成功",
    goToShop: "ポイントセンターへ",
    sortByLastPost: "最近のコメント",
    sortByTime: "最新",
    tags: {
      activity: "イベント",
      chats: "交流",
      guide: "攻略",
      recommend: "おすすめ",
      news: "ニュース",
    },
    unboundRole: "キャラクターを連携していません",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "メンテナンス中",
    message:
      "申し訳ございませんが、現在ゲームフォーラムはメンテナンス中です。しばらくしてからもう一度お試しください。",
  },
  mentionModal: {
    searchPlaceholder: "ユーザーを検索",
    title: "ユーザーを選択",
  },
  nicknameModify: {
    alreadyRenamed:
      "ニックネームの変更は月1回までです。今月はすでに変更済みです",
    changedNickname: "ニックネーム変更",
    cost: "コスト",
    date: "日付",
    getMore: "入手",
    nicknameTooShort: "ニックネームは3文字以上にしてください",
    coinNotEnough: "ポイント不足",
    placeholder: "ニックネームを入力してください",
    recordTitle: "変更履歴",
    sameNickname: "ニックネームは現在のものと同じにすることはできません",
    success: "修正成功",
    viewRecord: "変更履歴を確認",
  },
  notice: {
    empty: "メッセージはありません",
    likeComment: "{username}があなたのコメントにいいねしました",
    likePost: "{username}があなたの投稿にいいねしました",
    mentionComment: "{username}さんがあなたのコメントに{'@'}しました",
    mentionPost: "{username}さんがあなたの投稿に{'@'}しました",
    replyComment: "{username}さんがあなたのコメントに返信しました",
    replyPost: "{username}さんがあなたの投稿に返信しました",
    system: "システム通知",
    tabs: {
      like: "いいね",
      mention: "メンション",
      notification: "通知",
      reply: "返信",
    },
    title: "メッセージ通知",
  },
  operateModal: {
    confirmDelete: "この投稿を削除してもよろしいですか？",
    copyFailed: "コピー失敗",
    copyLink: "リンクをコピー",
    delete: "削除",
    shareToGame: "ゲーム内で共有",
    copySuccess: "コピーしました",
    deleteFailed: "削除失敗",
    deleteSuccess: "削除完了",
    title: "操作",
  },
  shareModal: {
    selectChannelTitle: "共有先のチャンネルを選択してください",
    channelLabel: "チャンネル",
    channelPlaceholder: "チャンネルを選択",
    alliance: "同盟",
    shareSuccess: "共有しました",
    continueBrowse: "続けて閲覧",
    goToGame: "ゲームで見る",
    noThreadTip: "投稿を開いてから操作してください",
  },
  post: {
    create: {
      contentEmpty: "内容を空欄にすることはできません",
      contentPlaceholder: "今の気持ちを書いてみよう...",
      failed: "投稿失敗",
      fileTooLarge: "ファイルサイズが制限を超えています（最大 {maxSize}）",
      image: "画像",
      imageSizeLimit: "画像サイズは5MBを超えることができません",
      imageUploadFailed: "画像アップロード失敗",
      imageUploadSuccess: "画像アップロード成功",
      imageUploading: "画像をアップロード中、しばらくお待ちください...",
      invalidFileType: "対応していないファイルタイプです",
      maxCharsReached: "最大文字数に達しました ({max} 文字)",
      mention: "{'@'}",
      selectBoard: "スレッドを選択",
      topicLabel: "トピック",
      submit: "投稿",
      submitting: "投稿中...",
      success: "投稿成功",
      title: "投稿",
      titleEmpty: "タイトルを空にすることはできません",
      titlePlaceholder: "タイトルを入力してください",
      video: "動画",
      videoSizeLimit: "動画サイズは50MBを超えることができません",
      videoUploadFailed: "動画アップロード失敗",
      videoUploadSuccess: "動画アップロード成功",
      videoUploading: "動画をアップロード中です。しばらくお待ちください...",
    },
    title: "投稿",
  },
  postDetail: {
    allComments: "全部で{num}件の返信",
    allReplies: "全ての返信",
    author: "作者",
    cancelFavorite: "お気に入りから削除しました",
    commentTooShort: "コメントは5文字以上入力してください",
    translate: "翻訳",
    translating: "翻訳中...",
    translateSuccess: "翻訳成功",
    translateFailed: "翻訳失敗",
    translatedTo: "翻訳済み",
    earliest: "最も古い返信",
    favoriteSuccess: "お気に入りに追加しました",
    floor: "レス",
    latest: "最新の返信",
    loadFailed: "読み込みに失敗しました",
    noContent: "内容がありません",
    onlyAuthor: "作者のみ表示",
    reply: "返信",
    replyTo: "返信",
    sendFailed: "送信に失敗しました",
    sendSuccess: "送信完了",
    sending: "送信中...",
    viewOriginalPost: "元の投稿を見る",
    writeSomething: "何か書いてみよう...",
  },
  profile: {
    addLikeSuccess: "いいねしました",
    cancelLikeSuccess: "いいねを取り消しました",
    communityId: "コミュニティID",
    editNickname: "ニックネーム変更",
    followSuccess: "フォロー成功",
    followed: "フォロー中",
    followers: "フォロワー",
    follow: "フォロー",
    likes: "いいねされました",
    noFavorites: "お気に入りはありません",
    noPosts: "アクションはありません",
    shopLabel: "ポイントショップ",
    tabs: {
      favorites: "お気に入り",
      posts: "マイアクション",
    },
    title: "マイページ",
    unfollowSuccess: "フォロー解除が完了しました",
  },
  search: {
    btn: "検索",
    empty: "関連する検索結果はありません",
    filter: {
      dateline: "最新",
      title: "並替",
      views: "人気",
    },
    historyTitle: "検索履歴",
    hotTitle: "トレンド検索",
    relatedPosts: "関連投稿",
    tabs: {
      post: "投稿",
      user: "ユーザー",
    },
  },
  setting: {
    about: "私たちについて",
    logout: "ログアウト",
    logoutSuccess: "ログアウトしました",
    privacy: "プライバシーポリシー",
    service: "利用規約",
    title: "設定",
  },
  shop: {
    emptyTip: "ショップは只今準備中です。お楽しみに！",
    record: "交換履歴",
    title: "交換センター",
    bindRole: "キャラ連携",
    switchRole: "キャラクター切り替え",
    tabs: {
      tasks: "ポイントタスク",
      rewards: "報酬交換",
    },
    taskInProgress: "進行中",
    taskCompleted: "完了",
    goToComplete: "完了へ",
    exchange: "交換",
    exchanged: "交換済み",
    exchangeConfirmTitle: "報酬を交換しますか？",
    currentCoins: "現在のポイント",
    costCoins: "消費ポイント",
    receiveRole: "受け取りキャラ",
    exchangeSuccess: "交換成功",
    exchangeFailed: "交換失敗",
  },
  exchangeRecord: {
    time: "時間",
    content: "内容",
    points: "ポイント",
    empty: "交換記録がありません",
  },
  tabBar: {
    home: "ホーム",
    notice: "メッセージ",
    profile: "マイページ",
  },
  time: {
    hoursAgo: "{hours}時間前",
    minutesAgo: "{minutes}分前",
  },
};
